import { useEffect, useState, type SyntheticEvent } from "react";
import { Box, Tab, Tabs } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import type { ExtendedVisionUser } from "@thalamos/vision-common";

import { IncidentManagement } from "../../components/Admin/Incident/Incident.js";
import { LocationPrecisionOverrideManagement } from "../../components/Admin/LocationPrecisionOverride/index.js";
import { OrganisationsManagement } from "../../components/Admin/Organisations/OrganisationsManagement.js";
import { SupervisorSyncExemptionsManagement } from "../../components/Admin/SupervisorSyncExemptions/SupervisorSyncExemptionsManagement.js";
import { UserDirectoryInstancesManagement } from "../../components/Admin/UserDirectoryInstances/UserDirectoryInstancesManagement.js";
import { UsersManagement } from "../../components/Admin/Users/UsersManagement.js";
import { createRoute } from "../../routing/createRoute.js";

export type AdminPageProps = {
  user: ExtendedVisionUser;
};

export function AdminPage({ user }: AdminPageProps) {
  const { t } = useTranslation();
  const [tab, setTab] = useState(0);
  const navigate = useNavigate();
  const handleChange = (_event: SyntheticEvent, newTab: number) => {
    setTab(newTab);
  };

  useEffect(() => {
    const isAdminUser = user?.isAdminSession;
    if (!isAdminUser) {
      navigate(createRoute.home());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Box>
      <Tabs
        sx={{ padding: "1em 0" }}
        variant="scrollable"
        scrollButtons="auto"
        value={tab}
        onChange={handleChange}
      >
        <Tab label={t("admin.tabs.incidents")} value={0} />
        <Tab label={t("admin.tabs.organisations")} value={1} />
        <Tab label={t("admin.tabs.userList")} value={2} />
        <Tab label={t("admin.tabs.locationPrecisionOverrides")} value={3} />
        <Tab label={t("admin.tabs.userDirectoryInstances")} value={4} />
        <Tab label={t("admin.tabs.supervisorSyncExemptions")} value={5} />
      </Tabs>
      <Box>{tab === 0 && <IncidentManagement />}</Box>
      <Box>{tab === 1 && <OrganisationsManagement />}</Box>
      <Box>{tab === 2 && <UsersManagement />}</Box>
      <Box>{tab === 3 && <LocationPrecisionOverrideManagement />}</Box>
      <Box>{tab === 4 && <UserDirectoryInstancesManagement />}</Box>
      <Box>{tab === 5 && <SupervisorSyncExemptionsManagement />}</Box>
    </Box>
  );
}
